// :cow: Cosmose CONFIDENTIAL :iso:
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { SnackbarService } from '@coa/app/libs/services/snackbar.service';
import { Store } from '@ngrx/store';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { categoriesRequested, categoriesRequestFailed, categoriesRequestSucceeded } from './select-category.actions';
import { SelectCategoryService } from '../services/select-category.service';
import { CategoriesResponse } from '../models/category';

@Injectable()
export class SelectCategoryEffects {

  categoriesRequested$ = createEffect(() =>
    this.actions$.pipe(
      ofType(categoriesRequested),
      mergeMap((action) => this.categoriesService.getCategories(action.clientId).pipe(
        map((categoriesResponse: CategoriesResponse) => categoriesRequestSucceeded({categoriesResponse})),
        catchError(() => of(categoriesRequestFailed())),
      )),
    ), {dispatch: true},
  );

  constructor(private actions$: Actions,
              private store$: Store,
              private snackbarService: SnackbarService,
              private categoriesService: SelectCategoryService) {
  }
}
